export default {
  title: 'Valider l\'adresse',
  streetNumber: 'Numéro de rue',
  streetNumberWarning: 'Veuillez renseigner un numéro de rue valide',
  street: 'Rue',
  streetWarning: 'Veuillez renseigner une rue',
  city: 'Ville',
  cityWarning: 'Veuillez renseigner une ville',
  postal: 'Code postal',
  postalWarning: 'Veuillez renseigner un code postal valide',
  country: 'Pays',
  countryWarning: 'Veuillez renseigner un pays',
  region: 'Region',
  regionWarning: 'Veuillez renseigner une région',
  unknowAddress: 'L\'adresse n\'est pas encore connue',
};
